export const PORTAL_ELEMENTS_APPEARANCE = {
  theme: {
    appearance: "light",
    accentColor: "blue",
    grayColor: "slate",
    dangerColor: "red",
    warningColor: "orange",
    successColor: "blue",
    infoColor: "sky",
  },
  variables: {
    "--radius": "10px",
    "--color-background": "#f8f9fb",
    "--color-panel-solid": "#ffffff",
    "--color-panel-translucent": "#ffffff",
    "--color-stroke": "rgba(24, 24, 24, 0.10)",
    "--default-font-family": '"Figtree", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--heading-font-family": '"Figtree", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--strong-font-family": '"Figtree", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--default-letter-spacing": "-0.01em",
    "--heading-letter-spacing": "-0.035em",
    "--table-row-background-color": "transparent",
    "--accent-1": "#fdfdfe",
    "--accent-2": "#f8faff",
    "--accent-3": "#eaf1fb",
    "--accent-4": "#dce9fa",
    "--accent-5": "#c9dbf8",
    "--accent-6": "#b2cbf4",
    "--accent-7": "#96b6ef",
    "--accent-8": "#6fa1ec",
    "--accent-9": "#2d64ef",
    "--accent-10": "#1e5ecc",
    "--accent-11": "#154ab3",
    "--accent-12": "#12285c",
    "--accent-9-contrast": "#ffffff",
    "--gray-1": "#ffffff",
    "--gray-2": "#fafbfc",
    "--gray-3": "#f2f3f6",
    "--gray-4": "#e9ebee",
    "--gray-5": "#e1e3e8",
    "--gray-6": "#d7dade",
    "--gray-7": "#c8ccd2",
    "--gray-8": "#a8adb8",
    "--gray-9": "#7b8090",
    "--gray-10": "#6d7280",
    "--gray-11": "#565b66",
    "--gray-12": "#181818",
    "--orange-9": "#f76b15",
    "--orange-10": "#ef5f00",
    "--orange-11": "#cc4e00",
    "--orange-12": "#582d1d",
    "--amber-1": "#fdfdfe",
    "--amber-2": "#fafbfc",
    "--amber-3": "#f2f3f6",
    "--amber-4": "#e9ebee",
    "--amber-5": "#e1e3e8",
    "--amber-6": "#d7dade",
    "--amber-7": "#c8ccd2",
    "--amber-8": "#a8adb8",
    "--amber-9": "#ffc53d",
    "--amber-10": "#ffba18",
    "--amber-11": "#ab6400",
    "--amber-12": "#4f3422",
    "--amber-a2": "rgba(24, 24, 24, 0.025)",
    "--amber-surface": "rgba(255, 197, 61, 0.08)",
    "--amber-9-contrast": "#181818",
    "--yellow-1": "#fdfdfe",
    "--yellow-2": "#fafbfc",
    "--yellow-3": "#f2f3f6",
    "--yellow-4": "#e9ebee",
    "--yellow-5": "#e1e3e8",
    "--yellow-6": "#d7dade",
    "--yellow-7": "#c8ccd2",
    "--yellow-8": "#a8adb8",
    "--yellow-9": "#ffc53d",
    "--yellow-10": "#ffba18",
    "--yellow-11": "#ab6400",
    "--yellow-12": "#4f3422",
    "--yellow-a2": "rgba(24, 24, 24, 0.025)",
    "--yellow-surface": "rgba(255, 197, 61, 0.08)",
    "--yellow-9-contrast": "#181818",
  },
  classes: {
    "whop-FieldLabel": { fontSize: "15px", fontWeight: "650" },
    "whop-FieldDescription": { fontSize: "13px", lineHeight: "1.5" },
    "whop-InputRoot": { minHeight: "48px", borderRadius: "10px" },
    "whop-Input": { padding: "12px 14px", fontSize: "15px" },
    "whop-SelectTrigger": { minHeight: "48px", padding: "10px 14px", borderRadius: "10px", fontSize: "15px" },
    "whop-SelectPopup": { borderRadius: "10px" },
    "whop-DialogContent": { borderRadius: "18px" },
    "whop-DialogHeader": { padding: "20px 22px" },
    "whop-DialogBody": { padding: "20px 22px" },
    "whop-DialogFooter": { padding: "16px 22px 20px" },
  },
};
